// extracted by mini-css-extract-plugin
export default {"BudgetAddForm":"BudgetAddForm_BudgetAddForm__JZMjy"};